import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) { super(props); this.state = { hasError: false }; }
    static getDerivedStateFromError() { return { hasError: true }; }
    componentDidCatch(error, info) { console.error('ErrorBoundary caught:', error, info); }
    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: '8px 12px', margin: '4px 0', borderRadius: 6, background: '#fee', color: '#c00', fontSize: '0.85em' }}>
                    ⚠️ 메시지를 표시할 수 없습니다.
                    <button onClick={() => this.setState({ hasError: false })}
                        style={{ marginLeft: 8, fontSize: '0.85em', cursor: 'pointer', background: 'none', border: '1px solid #c00', borderRadius: 4, color: '#c00', padding: '1px 6px' }}>
                        재시도
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
